import { render, staticRenderFns } from "./invMove.vue?vue&type=template&id=37d28e3a&"
import script from "./invMove.vue?vue&type=script&lang=js&"
export * from "./invMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports